// Client mirror of snippets/gp-free-delivery-qualify.liquid (authoritative); keep the rules in sync.
(function () {
  'use strict';

  if (window.gpFreeDelivery) return;

  // Lists are comma-wrapped (",123,456,") to mirror Liquid `contains`.
  function has(list, id) {
    if (!list || !id) return false;
    return list.indexOf(`,${id},`) !== -1;
  }

  // Must match gp_is_gift in snippets/cart-drawer-custom.liquid.
  function isGift(item) {
    if (window.cartState && typeof window.cartState.isGiftLine === 'function') {
      return window.cartState.isGiftLine(item);
    }
    return !!(item && item.properties && item.properties._gp_free_gift);
  }

  // threshold and subMark are integer pence; a threshold of 0 disables the threshold rule.
  function qualify(cart, options) {
    const opts = options || {};
    const threshold = Number(opts.threshold) || 0;
    const largest = opts.largestPackVariants || '';
    const starter = opts.starterPackProducts || '';
    const allowLargest = opts.largestPackShipsFree !== false;
    const mark = Number(opts.subMark) || 0;

    const empty = {
      qualifies: false,
      reason: 'threshold',
      eligible: 0,
      threshold,
      remaining: threshold,
      percent: 0,
    };

    if (!cart) return empty;

    const items = cart.items || [];

    let giftTotal = 0;
    let lines = 0;
    let free = false;
    let reason = 'threshold';

    let starterOnly = true;

    items.forEach((item) => {
      if (isGift(item)) {
        giftTotal += item.final_line_price || 0;
        return;
      }

      lines += 1;

      if (!(starter && has(starter, item.product_id))) starterOnly = false;

      if (item.selling_plan_allocation) {
        // Per-unit price on purpose, to match the product page; not final_line_price.
        if (mark > 0 && (item.price || 0) >= mark) {
          free = true;
          reason = 'subscription_marked';
        } else if (allowLargest && !free && has(largest, item.variant_id || item.id)) {
          free = true;
          reason = 'largest_pack_subscription';
        }
      }
    });

    if (!free && lines > 0 && starterOnly && starter) {
      free = true;
      reason = 'starter_pack_only';
    }

    const eligible = Math.max(0, (cart.total_price || 0) - giftTotal);

    if (!free && threshold > 0 && eligible >= threshold) {
      free = true;
      reason = 'threshold';
    }

    if (free) {
      return { qualifies: true, reason, eligible, threshold, remaining: 0, percent: 100 };
    }

    return {
      qualifies: false,
      reason,
      eligible,
      threshold,
      remaining: Math.max(0, threshold - eligible),
      percent: threshold > 0 ? Math.min(100, Math.floor((eligible * 100) / threshold)) : 0,
    };
  }

  window.gpFreeDelivery = { qualify };
})();
